export function hipchatEmoticons() {
	// noop intentionally blank, Plugin loaded via WRM
}
export function hipchatEmoticonsWRM() {
	return [
		'wr!com.atlassian.confluence.plugins.confluence-hipchat-emoticons-plugin:hipchat-emoticons-conf-frontend',
	];
}
